import { render, staticRenderFns } from "./SkeletonCourseVideoFile.vue?vue&type=template&id=46c7073a&scoped=true"
import script from "./SkeletonCourseVideoFile.vue?vue&type=script&lang=js"
export * from "./SkeletonCourseVideoFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c7073a",
  null
  
)

export default component.exports